import { useI18n } from "@/context/I18nContext";
import { fmtPrice } from "@/lib/format";

function Card({ label, value, sublabel, color, testid }) {
  return (
    <div className="mq-panel p-4" data-testid={testid}>
      <div className="mq-label mb-2">{label}</div>
      <div className="mq-metric text-3xl sm:text-4xl" style={{ color: color || "var(--mq-text)" }}>
        {value}
      </div>
      {sublabel && (
        <div className="mt-2 text-[10px] text-[var(--mq-text-2)] tracking-wider uppercase">
          {sublabel}
        </div>
      )}
    </div>
  );
}

export default function KPIGrid({ state }) {
  const { t } = useI18n();
  const book = state?.order_book || {};
  const compliance = state?.compliance || {};
  const spread = compliance.spread_pct ?? 0;
  const depthBid = compliance.depth_bid_usd ?? 0;
  const depthAsk = compliance.depth_ask_usd ?? 0;
  const vol = compliance.volume_24h_usd ?? 0;
  const volTarget = compliance.volume_target ?? 0;
  const volPct = compliance.volume_pct ?? 0;
  const mid = book.mid ?? 0;

  const spreadColor = spread > 1.5 ? "var(--mq-red)" : spread > 1.2 ? "var(--mq-yellow)" : "var(--mq-green)";

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card
        testid="kpi-mid-price"
        label={`${state?.symbol || "—"} · ${t("price")}`}
        value={mid ? fmtPrice(mid, { withDollar: true }) : "—"}
        sublabel={state?.exchange?.toUpperCase()}
      />
      <Card
        testid="kpi-spread"
        label={t("spread")}
        value={`${spread.toFixed(3)}%`}
        sublabel={`cap ${(compliance.spread_pct != null ? state?.compliance?.spread_pct : 0, "1.40%")}`}
        color={spreadColor}
      />
      <Card
        testid="kpi-depth"
        label={`${t("depth")} (bid / ask)`}
        value={`$${Math.round(depthBid)} / $${Math.round(depthAsk)}`}
        sublabel={`min $200`}
        color={compliance.depth_ok ? "var(--mq-green)" : "var(--mq-red)"}
      />
      <Card
        testid="kpi-volume"
        label={`${t("volume24h")}`}
        value={`$${vol.toLocaleString(undefined, { maximumFractionDigits: 0 })}`}
        sublabel={`${t("target")} $${volTarget.toLocaleString()} · ${(volPct * 100).toFixed(0)}%`}
        color={
          compliance.volume_ok
            ? "var(--mq-green)"
            : volPct > 0.7
              ? "var(--mq-yellow)"
              : "var(--mq-red)"
        }
      />
    </div>
  );
}
